import { jsx as o } from "react/jsx-runtime";
import r from "./assets/arrows/ArrowBottom.js";
import m from "./assets/ui/ThumbsUp.js";
import t from "./assets/arrows/ArrowLeft.js";
import e from "./assets/arrows/ArrowRight.js";
import i from "./assets/arrows/ArrowTop.js";
import p from "./assets/arrows/ChevronDown.js";
import a from "./assets/arrows/ChevronLeft.js";
import f from "./assets/arrows/ChevronRight.js";
import l from "./assets/arrows/ChevronUp.js";
import n from "./assets/arrows/ChevronDropdown.js";
import s from "./assets/arrows/ExternalLink.js";
import c from "./assets/arrows/Download.js";
import h from "./assets/arrows/Refresh.js";
import u from "./assets/alerts/ChatExclamation.js";
import C from "./assets/alerts/Exclamation.js";
import g from "./assets/alerts/Info.js";
import k from "./assets/alerts/QuestionMark.js";
import w from "./assets/alerts/SpeechQuestion.js";
import d from "./assets/alerts/ChatBubbles.js";
import S from "./assets/alerts/CheckCircle.js";
import P from "./assets/alerts/Check.js";
import v from "./assets/alerts/CrossCircle.js";
import b from "./assets/alerts/Cross.js";
import L from "./assets/alerts/Minus.js";
import F from "./assets/alerts/Plus.js";
import B from "./assets/documents/Contract.js";
import H from "./assets/documents/Envelope.js";
import M from "./assets/documents/FileDownload.js";
import T from "./assets/documents/File.js";
import x from "./assets/documents/FileCheck.js";
import A from "./assets/documents/FileCross.js";
import y from "./assets/energy/Sun.js";
import E from "./assets/energy/Leaf.js";
import D from "./assets/energy/Water.js";
import R from "./assets/energy/Wind.js";
import q from "./assets/energy/SolarPanel.js";
import W from "./assets/energy/SolarPanelSlash.js";
import U from "./assets/energy/Electricity.js";
import I from "./assets/energy/Gas.js";
import O from "./assets/energy/Home.js";
import G from "./assets/energy/HomeSmile.js";
import Q from "./assets/energy/HomeCross.js";
import N from "./assets/energy/HomePerson.js";
import j from "./assets/energy/HomePersons.js";
import X from "./assets/energy/HomeSmallProducer.js";
import z from "./assets/energy/HomeBigProducer.js";
import J from "./assets/energy/AnalogMeter.js";
import K from "./assets/energy/Apartment.js";
import V from "./assets/energy/Avocado.js";
import Y from "./assets/energy/Blanket.js";
import Z from "./assets/energy/BlanketAlt.js";
import _ from "./assets/energy/Briefcase.js";
import $ from "./assets/energy/Car.js";
import oo from "./assets/energy/CarExhaust.js";
import ro from "./assets/energy/Chart.js";
import mo from "./assets/energy/Charts.js";
import to from "./assets/energy/ChartSlash.js";
import eo from "./assets/energy/Community.js";
import io from "./assets/energy/DigitalMeter.js";
import po from "./assets/energy/DoubleMeter.js";
import ao from "./assets/energy/Factory.js";
import fo from "./assets/energy/Hills.js";
import lo from "./assets/energy/Laptop.js";
import no from "./assets/energy/LineChart.js";
import so from "./assets/energy/Lock.js";
import co from "./assets/energy/Microwave.js";
import ho from "./assets/energy/Moon.js";
import uo from "./assets/energy/Office.js";
import Co from "./assets/energy/SaladBowl.js";
import go from "./assets/energy/Shop.js";
import ko from "./assets/energy/Shower.js";
import wo from "./assets/energy/SmartPhone.js";
import So from "./assets/energy/Steak.js";
import Po from "./assets/energy/Thermostat.js";
import vo from "./assets/energy/Trees.js";
import bo from "./assets/energy/TV.js";
import Lo from "./assets/energy/WashingMachine.js";
import Fo from "./assets/finance/Euro.js";
import Bo from "./assets/finance/PaymentCard.js";
import Ho from "./assets/finance/Receipt.js";
import Mo from "./assets/finance/ReceiptAlt.js";
import To from "./assets/time-location/Calendar.js";
import xo from "./assets/time-location/Clock.js";
import Ao from "./assets/time-location/Globe.js";
import yo from "./assets/time-location/Hourglass.js";
import Eo from "./assets/time-location/Location.js";
import Do from "./assets/users/PeopleHeart.js";
import Ro from "./assets/users/Person.js";
import qo from "./assets/users/PersonBig.js";
import Wo from "./assets/users/PersonFour.js";
import Uo from "./assets/users/PersonThree.js";
import Io from "./assets/users/PersonTwo.js";
import Oo from "./assets/users/UserCircle.js";
import Go from "./assets/ui/BadgeCheck.js";
import Qo from "./assets/ui/EllipsisH.js";
import No from "./assets/ui/FaceHappy.js";
import jo from "./assets/ui/FaceSad.js";
import Xo from "./assets/ui/FaceWow.js";
import zo from "./assets/ui/FlagNL.js";
import Jo from "./assets/ui/FlagFR.js";
import Ko from "./assets/ui/Gift.js";
import Vo from "./assets/ui/LogIn.js";
import Yo from "./assets/ui/LogOut.js";
import Zo from "./assets/ui/Menu.js";
import _o from "./assets/ui/Overview.js";
import $o from "./assets/ui/Placeholder.js";
import or from "./assets/ui/Search.js";
import rr from "./assets/ui/Star.js";
import mr from "./assets/logos/BoltLogo.js";
import tr from "./assets/logos/Facebook.js";
import er from "./assets/logos/FacebookLine.js";
import ir from "./assets/logos/FacebookSquare.js";
import pr from "./assets/logos/Instagram.js";
import ar from "./assets/logos/LinkedinSquare.js";
import fr from "./assets/logos/Messenger.js";
import lr from "./assets/logos/TiktokSquare.js";
import nr from "./assets/logos/WhatsappFill.js";
import sr from "./assets/logos/WhatsappLine.js";
import cr from "./assets/logos/XTwitter.js";
import hr from "./assets/ui/CameraPlus.js";
import ur from "./assets/ui/Pencil.js";
import Cr from "./assets/ui/Settings.js";
import gr from "./assets/arrows/Shuffle.js";
const Et = {
  // ALERTS
  chatBubbles: /* @__PURE__ */ o(d, {}),
  chatExclamation: /* @__PURE__ */ o(u, {}),
  check: /* @__PURE__ */ o(P, {}),
  checkCircle: /* @__PURE__ */ o(S, {}),
  cross: /* @__PURE__ */ o(b, {}),
  crossCircle: /* @__PURE__ */ o(v, {}),
  exclamation: /* @__PURE__ */ o(C, {}),
  info: /* @__PURE__ */ o(g, {}),
  minus: /* @__PURE__ */ o(L, {}),
  plus: /* @__PURE__ */ o(F, {}),
  questionMark: /* @__PURE__ */ o(k, {}),
  speechQuestion: /* @__PURE__ */ o(w, {}),
  // ARROWS
  arrowBottom: /* @__PURE__ */ o(r, {}),
  arrowLeft: /* @__PURE__ */ o(t, {}),
  arrowRight: /* @__PURE__ */ o(e, {}),
  arrowTop: /* @__PURE__ */ o(i, {}),
  chevronDown: /* @__PURE__ */ o(p, {}),
  chevronDropdown: /* @__PURE__ */ o(n, {}),
  chevronLeft: /* @__PURE__ */ o(a, {}),
  chevronRight: /* @__PURE__ */ o(f, {}),
  chevronUp: /* @__PURE__ */ o(l, {}),
  download: /* @__PURE__ */ o(c, {}),
  externalLink: /* @__PURE__ */ o(s, {}),
  shuffle: /* @__PURE__ */ o(gr, {}),
  refresh: /* @__PURE__ */ o(h, {}),
  // DOCUMENTS
  contract: /* @__PURE__ */ o(B, {}),
  envelope: /* @__PURE__ */ o(H, {}),
  file: /* @__PURE__ */ o(T, {}),
  fileCheck: /* @__PURE__ */ o(x, {}),
  fileCross: /* @__PURE__ */ o(A, {}),
  fileDownload: /* @__PURE__ */ o(M, {}),
  // ENERGY
  analogMeter: /* @__PURE__ */ o(J, {}),
  apartment: /* @__PURE__ */ o(K, {}),
  avocado: /* @__PURE__ */ o(V, {}),
  blanket: /* @__PURE__ */ o(Y, {}),
  blanketAlt: /* @__PURE__ */ o(Z, {}),
  briefcase: /* @__PURE__ */ o(_, {}),
  car: /* @__PURE__ */ o($, {}),
  carExhaust: /* @__PURE__ */ o(oo, {}),
  chart: /* @__PURE__ */ o(ro, {}),
  chartSlash: /* @__PURE__ */ o(to, {}),
  charts: /* @__PURE__ */ o(mo, {}),
  community: /* @__PURE__ */ o(eo, {}),
  digitalMeter: /* @__PURE__ */ o(io, {}),
  doubleMeter: /* @__PURE__ */ o(po, {}),
  electricity: /* @__PURE__ */ o(U, {}),
  factory: /* @__PURE__ */ o(ao, {}),
  gas: /* @__PURE__ */ o(I, {}),
  hills: /* @__PURE__ */ o(fo, {}),
  home: /* @__PURE__ */ o(O, {}),
  homeBigProducer: /* @__PURE__ */ o(z, {}),
  homeCross: /* @__PURE__ */ o(Q, {}),
  homePerson: /* @__PURE__ */ o(N, {}),
  homePersons: /* @__PURE__ */ o(j, {}),
  homeSmallProducer: /* @__PURE__ */ o(X, {}),
  homeSmile: /* @__PURE__ */ o(G, {}),
  laptop: /* @__PURE__ */ o(lo, {}),
  leaf: /* @__PURE__ */ o(E, {}),
  lineChart: /* @__PURE__ */ o(no, {}),
  lock: /* @__PURE__ */ o(so, {}),
  microwave: /* @__PURE__ */ o(co, {}),
  moon: /* @__PURE__ */ o(ho, {}),
  office: /* @__PURE__ */ o(uo, {}),
  saladBowl: /* @__PURE__ */ o(Co, {}),
  shop: /* @__PURE__ */ o(go, {}),
  shower: /* @__PURE__ */ o(ko, {}),
  smartPhone: /* @__PURE__ */ o(wo, {}),
  solarPanel: /* @__PURE__ */ o(q, {}),
  solarPanelSlash: /* @__PURE__ */ o(W, {}),
  steak: /* @__PURE__ */ o(So, {}),
  sun: /* @__PURE__ */ o(y, {}),
  thermostat: /* @__PURE__ */ o(Po, {}),
  trees: /* @__PURE__ */ o(vo, {}),
  tv: /* @__PURE__ */ o(bo, {}),
  washingMachine: /* @__PURE__ */ o(Lo, {}),
  water: /* @__PURE__ */ o(D, {}),
  wind: /* @__PURE__ */ o(R, {}),
  // FINANCE
  euro: /* @__PURE__ */ o(Fo, {}),
  paymentCard: /* @__PURE__ */ o(Bo, {}),
  receipt: /* @__PURE__ */ o(Ho, {}),
  receiptAlt: /* @__PURE__ */ o(Mo, {}),
  // TIME & LOCATION
  calendar: /* @__PURE__ */ o(To, {}),
  clock: /* @__PURE__ */ o(xo, {}),
  globe: /* @__PURE__ */ o(Ao, {}),
  hourglass: /* @__PURE__ */ o(yo, {}),
  location: /* @__PURE__ */ o(Eo, {}),
  // USERS
  peopleHeart: /* @__PURE__ */ o(Do, {}),
  person: /* @__PURE__ */ o(Ro, {}),
  personBig: /* @__PURE__ */ o(qo, {}),
  personFour: /* @__PURE__ */ o(Wo, {}),
  personThree: /* @__PURE__ */ o(Uo, {}),
  personTwo: /* @__PURE__ */ o(Io, {}),
  userCircle: /* @__PURE__ */ o(Oo, {}),
  // UI
  badgeCheck: /* @__PURE__ */ o(Go, {}),
  ellipsisH: /* @__PURE__ */ o(Qo, {}),
  faceHappy: /* @__PURE__ */ o(No, {}),
  faceSad: /* @__PURE__ */ o(jo, {}),
  faceWow: /* @__PURE__ */ o(Xo, {}),
  flagNl: /* @__PURE__ */ o(zo, {}),
  flagFr: /* @__PURE__ */ o(Jo, {}),
  gift: /* @__PURE__ */ o(Ko, {}),
  logIn: /* @__PURE__ */ o(Vo, {}),
  logOut: /* @__PURE__ */ o(Yo, {}),
  menu: /* @__PURE__ */ o(Zo, {}),
  overview: /* @__PURE__ */ o(_o, {}),
  placeholder: /* @__PURE__ */ o($o, {}),
  search: /* @__PURE__ */ o(or, {}),
  star: /* @__PURE__ */ o(rr, {}),
  thumbsUp: /* @__PURE__ */ o(m, {}),
  cameraPlus: /* @__PURE__ */ o(hr, {}),
  pencil: /* @__PURE__ */ o(ur, {}),
  settings: /* @__PURE__ */ o(Cr, {}),
  // LOGOS
  boltLogo: /* @__PURE__ */ o(mr, {}),
  facebook: /* @__PURE__ */ o(tr, {}),
  facebookLine: /* @__PURE__ */ o(er, {}),
  facebookSquare: /* @__PURE__ */ o(ir, {}),
  instagram: /* @__PURE__ */ o(pr, {}),
  linkedinSquare: /* @__PURE__ */ o(ar, {}),
  messenger: /* @__PURE__ */ o(fr, {}),
  tiktokSquare: /* @__PURE__ */ o(lr, {}),
  whatsappFill: /* @__PURE__ */ o(nr, {}),
  whatsappLine: /* @__PURE__ */ o(sr, {}),
  x: /* @__PURE__ */ o(cr, {})
};
export {
  Et as icons
};
